import { render, staticRenderFns } from "./CurationFilterDefaultLayout.vue?vue&type=template&id=a38afade&scoped=true"
import script from "./CurationFilterDefaultLayout.vue?vue&type=script&lang=js"
export * from "./CurationFilterDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38afade",
  null
  
)

export default component.exports